export default __webpack_public_path__ + "3a68402940488d193b8c20c96ca053e8.svg";